import React from "react";
import { Chip as MuiChip, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 20,
    borderRadius: 4,
    fontWeight: 700,
    fontSize: "0.65rem",
    textTransform: "uppercase",
  },
  active: {
    backgroundColor: "#E8F5E9",
    color: "#2E7D32",
    border: "1px solid #C8E6C9",
  },
  pending: {
    backgroundColor: "#FFF3E0",
    color: "#EF6C00",
    border: "1px solid #FFE0B2",
  },
  void: {
    backgroundColor: "#DEE2E6",
    color: "#6C757D",
    border: "1px solid #E9ECEF",
  },
  success: {
    backgroundColor: "#e6f4ea",
    color: "#1e8e3e",
  },
  warning: {
    backgroundColor: "#FFFDE7",
    color: "#856404",
    border: "1px solid #FFE082",
  },
  info: {
    backgroundColor: "#E3F2FD",
    color: "#1976D2",
  },
  error: {
    backgroundColor: "#FFEBEE",
    color: "#C62828",
  },
  plan: {
    height: 20,
    fontWeight: 800,
    fontSize: "0.6rem",
    backgroundColor: "#FFD140",
    color: "#000",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    border: "none",
  },
}));

export const SKChip = ({ size = "small", variant = "default", type = "default", className = "", ...props }) => {
  const classes = useStyles();

  const chipClasses = [classes.root, classes[type], className].filter(Boolean).join(" ");

  return <MuiChip className={chipClasses} size={size} variant={variant} type={type} {...props} />;
};
